module.exports = __webpack_public_path__ + "static/media/visibilitat-03.a09426a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/visibilitat/visibilitat-03.svg
// module id = 783
// module chunks = 0